import { selectAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(parts.keys)

const variants = {
  flushed: helpers.definePartsStyle({
    field: {
      _focus: {
        borderBottomColor: 'primary.400',
        boxShadow: 'none',
      },
    },
  }),
}

export default helpers.defineMultiStyleConfig({
  variants,
  defaultProps: {
    variant: 'flushed',
  },
})
